
export function Label({children, ...props}){
    return(
        <label 
            className="block text-sm font-medium text-gray-700 dark:text-gray-300"
            {...props}
        >
            {children}
        </label>
    )
}

//nuevo "block text-sm font-medium text-gray-700"

//vieja "block text-sm font-bold leading-6 text-gray-500"
//block text-sm font-medium text-gray-700 dark:text-gray-300